// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__UQAyQ","productName":"Table_productName__1oYhq"};